import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { NASIOL, webStructure } from '../nasiolContent';

const WebStructure = () => (
  <Box
    component="section"
    id="estructura"
    py={{ xs: 7, md: 10 }}
    px={{ xs: 2.5, sm: 4, md: 7 }}
    bgcolor={NASIOL.sand}
  >
    <Box maxWidth={1100} mx="auto">
      <Typography
        sx={{
          fontFamily: '"Outfit", "Source Sans 3", sans-serif',
          fontWeight: 700,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          fontSize: '0.75rem',
          color: NASIOL.lagoon,
          mb: 1.25,
        }}
      >
        {webStructure.overline}
      </Typography>
      <Typography
        component="h2"
        sx={{
          fontFamily: '"Space Grotesk", "Outfit", sans-serif',
          fontWeight: 700,
          letterSpacing: '-0.02em',
          fontSize: { xs: '1.85rem', md: '2.55rem' },
          color: NASIOL.ink,
          mb: 1.25,
          maxWidth: 640,
        }}
      >
        {webStructure.title}
      </Typography>
      <Typography
        sx={{
          fontFamily: '"Source Sans 3", "Outfit", sans-serif',
          color: NASIOL.inkMuted,
          fontSize: { xs: '1.05rem', md: '1.12rem' },
          lineHeight: 1.65,
          maxWidth: 620,
          mb: { xs: 4, md: 5 },
        }}
      >
        {webStructure.subtitle}
      </Typography>

      <Grid container spacing={0}>
        {webStructure.modules.map((mod, index) => (
          <Grid item xs={12} md={6} key={mod.id}>
            <Box
              py={{ xs: 3, md: 3.5 }}
              pr={{ md: index % 2 === 0 ? 4 : 0 }}
              pl={{ md: index % 2 === 1 ? 4 : 0 }}
              borderTop={`1px solid ${NASIOL.sandDeep}`}
              sx={{
                transition: 'transform 0.35s ease',
                '&:hover': { transform: 'translateX(4px)' },
              }}
            >
              <Typography
                sx={{
                  fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                  fontWeight: 800,
                  fontSize: '0.8rem',
                  color: NASIOL.sunset,
                  letterSpacing: '0.08em',
                  mb: 0.75,
                }}
              >
                {String(index + 1).padStart(2, '0')}
              </Typography>
              <Typography
                component="h3"
                sx={{
                  fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                  fontWeight: 800,
                  fontSize: { xs: '1.3rem', md: '1.45rem' },
                  color: NASIOL.ink,
                  mb: 1,
                }}
              >
                {mod.title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Source Sans 3", "Outfit", sans-serif',
                  color: NASIOL.inkMuted,
                  lineHeight: 1.7,
                  fontSize: '1.02rem',
                }}
              >
                {mod.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);

export default WebStructure;
